import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './session/auth.guard';
import { AuthaccessGuard } from './session/authaccess.guard';
import { AuthemailGuard } from './session/authemail.guard';
import { AuthFalseGuard } from './session/authfalse.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'terminos',
    loadChildren: () => import('./views/terminos/terminos.module').then(m => m.TerminosPageModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthPageModule),
    canActivate: [AuthFalseGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./views/login/login.module').then(m => m.LoginPageModule),
    canActivate: [AuthFalseGuard]
  },
  {
    path: 'registro',
    loadChildren: () => import('./views/registro/registro.module').then(m => m.RegistroPageModule),
    canActivate: [AuthFalseGuard]
  },
  {
    path: 'registro-externo',
    loadChildren: () => import('./views/registro-externo/registro-externo.module').then(m => m.RegistroExternoPageModule),
    canActivate: [AuthFalseGuard]
  },
  {
    path: 'verify-email',
    loadChildren: () => import('./views/verify-email/verify-email.module').then(m => m.VerifyEmailPageModule),
    canActivate: [AuthemailGuard]
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./views/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule),
    canActivate: [AuthFalseGuard]
  },
  {
    path: 'logout',
    loadChildren: () => import('./views/logout/logout.module').then(m => m.LogoutPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'perfil',
    loadChildren: () => import('./views/perfil/perfil.module').then(m => m.PerfilPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'perfil-edit',
    loadChildren: () => import('./views/perfil-edit/perfil-edit.module').then(m => m.PerfilEditPageModule),
    canActivate: [AuthGuard]
  },
  
  // **********************************************
  /* App - Admin */
  {
    path: 'admin-dashboard',
    loadChildren: () => import('./views/app-admin/admin-dashboard/admin-dashboard.module').then(m => m.AdminDashboardPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-webservice',
    loadChildren: () => import('./views/app-admin/admin-webservice/admin-webservice.module').then(m => m.AdminWebservicePageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-webservice-pay',
    loadChildren: () => import('./views/app-admin/admin-webservice-pay/admin-webservice-pay.module').then(m => m.AdminWebservicePayPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-webservice-post',
    loadChildren: () => import('./views/app-admin/admin-webservice-post/admin-webservice-post.module').then(m => m.AdminWebservicePostPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-clientes',
    loadChildren: () => import('./views/app-admin/admin-clientes/admin-clientes.module').then(m => m.AdminClientesPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-cliente-edit',
    loadChildren: () => import('./views/app-admin/admin-cliente-edit/admin-cliente-edit.module').then(m => m.AdminClienteEditPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-cliente-edit/:idUser',
    loadChildren: './views/app-admin/admin-cliente-edit/admin-cliente-edit.module#AdminClienteEditPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-propietarios',
    loadChildren: () => import('./views/app-admin/admin-propietarios/admin-propietarios.module').then(m => m.AdminPropietariosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-propietario-edit',
    loadChildren: () => import('./views/app-admin/admin-propietario-edit/admin-propietario-edit.module').then(m => m.AdminPropietarioEditPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-propietario-edit/:idUser',
    loadChildren: './views/app-admin/admin-propietario-edit/admin-propietario-edit.module#AdminPropietarioEditPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-transportadores',
    loadChildren: () => import('./views/app-admin/admin-transportadores/admin-transportadores.module').then(m => m.AdminTransportadoresPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-transportador-edit',
    loadChildren: () => import('./views/app-admin/admin-transportador-edit/admin-transportador-edit.module').then(m => m.AdminTransportadorEditPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-transportador-edit/:idUser',
    loadChildren: './views/app-admin/admin-transportador-edit/admin-transportador-edit.module#AdminTransportadorEditPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-transportador-vehiculo',
    loadChildren: () => import('./views/app-admin/admin-transportador-vehiculo/admin-transportador-vehiculo.module').then(m => m.AdminTransportadorVehiculoPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-transportador-vehiculo/:idUser',
    loadChildren: './views/app-admin/admin-transportador-vehiculo/admin-transportador-vehiculo.module#AdminTransportadorVehiculoPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-comercios',
    loadChildren: () => import('./views/app-admin/admin-comercios/admin-comercios.module').then(m => m.AdminComerciosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-comercio-edit',
    loadChildren: () => import('./views/app-admin/admin-comercio-edit/admin-comercio-edit.module').then(m => m.AdminComercioEditPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-comercio-edit/:idUser',
    loadChildren: './views/app-admin/admin-comercio-edit/admin-comercio-edit.module#AdminComercioEditPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-comercio-productos',
    loadChildren: () => import('./views/app-admin/admin-comercio-productos/admin-comercio-productos.module').then(m => m.AdminComercioProductosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-comercio-productos/:idUser',
    loadChildren: './views/app-admin/admin-comercio-productos/admin-comercio-productos.module#AdminComercioProductosPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-pedidos',
    loadChildren: () => import('./views/app-admin/admin-pedidos/admin-pedidos.module').then(m => m.AdminPedidosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-pedido-view',
    loadChildren: () => import('./views/app-admin/admin-pedido-view/admin-pedido-view.module').then(m => m.AdminPedidoViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-pedido-view/:idPedido',
    loadChildren: './views/app-admin/admin-pedido-view/admin-pedido-view.module#AdminPedidoViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-encargas',
    loadChildren: () => import('./views/app-admin/admin-encargas/admin-encargas.module').then(m => m.AdminEncargasPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-encarga-view',
    loadChildren: () => import('./views/app-admin/admin-encarga-view/admin-encarga-view.module').then(m => m.AdminEncargaViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-encarga-view/:idEncarga',
    loadChildren: './views/app-admin/admin-encarga-view/admin-encarga-view.module#AdminEncargaViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-encargas-post',
    loadChildren: () => import('./views/app-admin/admin-encargas-post/admin-encargas-post.module').then(m => m.AdminEncargasPostPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-encarga-post-view',
    loadChildren: () => import('./views/app-admin/admin-encarga-post-view/admin-encarga-post-view.module').then(m => m.AdminEncargaPostViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-encarga-post-view/:idEncarga',
    loadChildren: './views/app-admin/admin-encarga-post-view/admin-encarga-post-view.module#AdminEncargaPostViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-central',
    loadChildren: () => import('./views/app-admin/admin-central/admin-central.module').then(m => m.AdminCentralPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-central-chat',
    loadChildren: () => import('./views/app-admin/admin-central-chat/admin-central-chat.module').then(m => m.AdminCentralChatPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  {
    path: 'admin-central-chat/:idCentral',
    loadChildren: './views/app-admin/admin-central-chat/admin-central-chat.module#AdminCentralChatPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'admin'
    }
  },
  // **********************************************
  /* App - Propietario */
  {
    path: 'propietario-dashboard',
    loadChildren: () => import('./views/app-propietario/propietario-dashboard/propietario-dashboard.module').then(m => m.PropietarioDashboardPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-vehiculos',
    loadChildren: () => import('./views/app-propietario/propietario-vehiculos/propietario-vehiculos.module').then(m => m.PropietarioVehiculosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-encargas',
    loadChildren: () => import('./views/app-propietario/propietario-encargas/propietario-encargas.module').then(m => m.PropietarioEncargasPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-encargas/:idVehiculo',
    loadChildren: './views/app-propietario/propietario-encargas/propietario-encargas.module#PropietarioEncargasPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-encarga-view',
    loadChildren: () => import('./views/app-propietario/propietario-encarga-view/propietario-encarga-view.module').then(m => m.PropietarioEncargaViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-encarga-view/:idEncarga',
    loadChildren: './views/app-propietario/propietario-encarga-view/propietario-encarga-view.module#PropietarioEncargaViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-encargas-post',
    loadChildren: () => import('./views/app-propietario/propietario-encargas-post/propietario-encargas-post.module').then(m => m.PropietarioEncargasPostPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-encargas-post/:idVehiculo',
    loadChildren: './views/app-propietario/propietario-encargas-post/propietario-encargas-post.module#PropietarioEncargasPostPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-encarga-post-view',
    loadChildren: () => import('./views/app-propietario/propietario-encarga-post-view/propietario-encarga-post-view.module').then(m => m.PropietarioEncargaPostViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-encarga-post-view/:idEncarga',
    loadChildren: './views/app-propietario/propietario-encarga-post-view/propietario-encarga-post-view.module#PropietarioEncargaPostViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  {
    path: 'propietario-central',
    loadChildren: () => import('./views/app-propietario/propietario-central/propietario-central.module').then(m => m.PropietarioCentralPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'propietario'
    }
  },
  // **********************************************
  /* App - Transportador */
  {
    path: 'transportador-dashboard',
    loadChildren: () => import('./views/app-transportador/transportador-dashboard/transportador-dashboard.module').then(m => m.TransportadorDashboardPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-vehiculo',
    loadChildren: () => import('./views/app-transportador/transportador-vehiculo/transportador-vehiculo.module').then(m => m.TransportadorVehiculoPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-vehiculo-add',
    loadChildren: () => import('./views/app-transportador/transportador-vehiculo-add/transportador-vehiculo-add.module').then(m => m.TransportadorVehiculoAddPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-encargas',
    loadChildren: () => import('./views/app-transportador/transportador-encargas/transportador-encargas.module').then(m => m.TransportadorEncargasPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-servicio',
    loadChildren: () => import('./views/app-transportador/transportador-servicio/transportador-servicio.module').then(m => m.TransportadorServicioPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-servicio-post',
    loadChildren: () => import('./views/app-transportador/transportador-servicio-post/transportador-servicio-post.module').then( m => m.TransportadorServicioPostPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-encarga-view',
    loadChildren: () => import('./views/app-transportador/transportador-encarga-view/transportador-encarga-view.module').then(m => m.TransportadorEncargaViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-encarga-view/:idEncarga',
    loadChildren: './views/app-transportador/transportador-encarga-view/transportador-encarga-view.module#TransportadorEncargaViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-encargas-post',
    loadChildren: () => import('./views/app-transportador/transportador-encargas-post/transportador-encargas-post.module').then(m => m.TransportadorEncargasPostPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-encarga-post-view',
    loadChildren: () => import('./views/app-transportador/transportador-encarga-post-view/transportador-encarga-post-view.module').then(m => m.TransportadorEncargaPostViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-encarga-post-view/:idEncarga',
    loadChildren: './views/app-transportador/transportador-encarga-post-view/transportador-encarga-post-view.module#TransportadorEncargaPostViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-encarga-chat',
    loadChildren: () => import('./views/app-transportador/transportador-encarga-chat/transportador-encarga-chat.module').then(m => m.TransportadorEncargaChatPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-encarga-chat/:idEncarga',
    loadChildren: './views/app-transportador/transportador-encarga-chat/transportador-encarga-chat.module#TransportadorEncargaChatPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-adicional',
    loadChildren: () => import('./views/app-transportador/transportador-adicional/transportador-adicional.module').then(m => m.TransportadorAdicionalPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-adicional-pay',
    loadChildren: () => import('./views/app-transportador/transportador-adicional-pay/transportador-adicional-pay.module').then(m => m.TransportadorAdicionalPayPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  {
    path: 'transportador-central',
    loadChildren: () => import('./views/app-transportador/transportador-central/transportador-central.module').then(m => m.TransportadorCentralPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'transportador'
    }
  },
  // **********************************************
  /* App - Comercio */
  {
    path: 'comercio-dashboard',
    loadChildren: () => import('./views/app-comercio/comercio-dashboard/comercio-dashboard.module').then(m => m.ComercioDashboardPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-pedidos',
    loadChildren: () => import('./views/app-comercio/comercio-pedidos/comercio-pedidos.module').then(m => m.ComercioPedidosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-productos',
    loadChildren: () => import('./views/app-comercio/comercio-productos/comercio-productos.module').then(m => m.ComercioProductosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-producto-add',
    loadChildren: () => import('./views/app-comercio/comercio-producto-add/comercio-producto-add.module').then(m => m.ComercioProductoAddPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-producto-edit',
    loadChildren: () => import('./views/app-comercio/comercio-producto-edit/comercio-producto-edit.module').then(m => m.ComercioProductoEditPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-producto-edit/:idProducto',
    loadChildren: './views/app-comercio/comercio-producto-edit/comercio-producto-edit.module#ComercioProductoEditPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-pedido-view',
    loadChildren: () => import('./views/app-comercio/comercio-pedido-view/comercio-pedido-view.module').then(m => m.ComercioPedidoViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-pedido-view/:idPedido',
    loadChildren: './views/app-comercio/comercio-pedido-view/comercio-pedido-view.module#ComercioPedidoViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-pedido-transporte',
    loadChildren: () => import('./views/app-comercio/comercio-pedido-transporte/comercio-pedido-transporte.module').then(m => m.ComercioPedidoTransportePageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-pedido-transporte/:idPedido',
    loadChildren: './views/app-comercio/comercio-pedido-transporte/comercio-pedido-transporte.module#ComercioPedidoTransportePageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-card',
    loadChildren: () => import('./views/app-comercio/comercio-card/comercio-card.module').then(m => m.ComercioCardPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-encargas',
    loadChildren: () => import('./views/app-comercio/comercio-encargas/comercio-encargas.module').then(m => m.ComercioEncargasPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-encarga-view',
    loadChildren: () => import('./views/app-comercio/comercio-encarga-view/comercio-encarga-view.module').then(m => m.ComercioEncargaViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-encarga-view/:idEncarga',
    loadChildren: './views/app-comercio/comercio-encarga-view/comercio-encarga-view.module#ComercioEncargaViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-encarga-chat',
    loadChildren: () => import('./views/app-comercio/comercio-encarga-chat/comercio-encarga-chat.module').then(m => m.ComercioEncargaChatPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-encarga-chat/:idEncarga',
    loadChildren: './views/app-comercio/comercio-encarga-chat/comercio-encarga-chat.module#ComercioEncargaChatPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  {
    path: 'comercio-central',
    loadChildren: () => import('./views/app-comercio/comercio-central/comercio-central.module').then(m => m.ComercioCentralPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'comercio'
    }
  },
  // **********************************************
  /* App - Cliente */
  {
    path: 'cliente-dashboard',
    loadChildren: () => import('./views/app-cliente/cliente-dashboard/cliente-dashboard.module').then(m => m.ClienteDashboardPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-pedidos',
    loadChildren: () => import('./views/app-cliente/cliente-pedidos/cliente-pedidos.module').then(m => m.ClientePedidosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-encargas',
    loadChildren: () => import('./views/app-cliente/cliente-encargas/cliente-encargas.module').then(m => m.ClienteEncargasPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-encarga',
    loadChildren: () => import('./views/app-cliente/cliente-encarga/cliente-encarga.module').then(m => m.ClienteEncargaPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-encarga-pay',
    loadChildren: () => import('./views/app-cliente/cliente-encarga-pay/cliente-encarga-pay.module').then(m => m.ClienteEncargaPayPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-encarga-view',
    loadChildren: () => import('./views/app-cliente/cliente-encarga-view/cliente-encarga-view.module').then(m => m.ClienteEncargaViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-encarga-view/:idEncarga',
    loadChildren: './views/app-cliente/cliente-encarga-view/cliente-encarga-view.module#ClienteEncargaViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-encarga-chat',
    loadChildren: () => import('./views/app-cliente/cliente-encarga-chat/cliente-encarga-chat.module').then(m => m.ClienteEncargaChatPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-encarga-chat/:idEncarga',
    loadChildren: './views/app-cliente/cliente-encarga-chat/cliente-encarga-chat.module#ClienteEncargaChatPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-tienda',
    loadChildren: () => import('./views/app-cliente/cliente-tienda/cliente-tienda.module').then(m => m.ClienteTiendaPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-comercios',
    loadChildren: () => import('./views/app-cliente/cliente-comercios/cliente-comercios.module').then(m => m.ClienteComerciosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-comercios/:idCategoria',
    loadChildren: './views/app-cliente/cliente-comercios/cliente-comercios.module#ClienteComerciosPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-productos',
    loadChildren: () => import('./views/app-cliente/cliente-productos/cliente-productos.module').then(m => m.ClienteProductosPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-productos/:idComercio/:idCategoria',
    loadChildren: './views/app-cliente/cliente-productos/cliente-productos.module#ClienteProductosPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-cart',
    loadChildren: () => import('./views/app-cliente/cliente-cart/cliente-cart.module').then(m => m.ClienteCartPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-cart-pay',
    loadChildren: () => import('./views/app-cliente/cliente-cart-pay/cliente-cart-pay.module').then(m => m.ClienteCartPayPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-card',
    loadChildren: () => import('./views/app-cliente/cliente-card/cliente-card.module').then(m => m.ClienteCardPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-pedido-view',
    loadChildren: () => import('./views/app-cliente/cliente-pedido-view/cliente-pedido-view.module').then(m => m.ClientePedidoViewPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-pedido-view/:idPedido',
    loadChildren: './views/app-cliente/cliente-pedido-view/cliente-pedido-view.module#ClientePedidoViewPageModule',
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  {
    path: 'cliente-central',
    loadChildren: () => import('./views/app-cliente/cliente-central/cliente-central.module').then(m => m.ClienteCentralPageModule),
    canActivate: [AuthaccessGuard],
    data: {
      role: 'cliente'
    }
  },
  
  
  /* {
    path: '**',
    loadChildren: () => import('./views/page-not-found/page-not-found.module').then( m => m.PageNotFoundPageModule)
  }, */


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
